import { render, staticRenderFns } from "./VenteNegoce.vue?vue&type=template&id=2b338b58"
import script from "./VenteNegoce.vue?vue&type=script&lang=js"
export * from "./VenteNegoce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports